import { analyticsDashboard as TYPES } from './../action_types';
import * as Ajax from './services';

const fetch = function () {
  return function (dispatch, getState) {
    if (
      getState().AnalyticsDashboard.ResearchInterestPercentiles.meta.exhausted
    )
      return;
    if (getState().AnalyticsDashboard.ResearchInterestPercentiles.meta.fetching)
      return;

    dispatch({
      type: TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_REQUEST,
    });

    $.when(Ajax.PercentilesService())
      .done(function (response) {
        dispatch({
          type: TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_SUCCESS,
          researchInterestPercentiles: response.research_interest_percentiles,
        });
      })
      .fail(function () {
        dispatch({
          type: TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_FAILURE,
        });
      });
  };
};

const ResearchInterestPercentiles = {
  fetch: fetch,
};
export { ResearchInterestPercentiles };

const initialState = {
  models: [],
  meta: {
    exhausted: false,
    fetching: false,
    errorFetching: false,
  },
};

const reducer = function (state = initialState, action) {
  switch (action.type) {
    case TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_REQUEST:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: true,
        }),
      });

    case TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_SUCCESS:
      return Object.assign({}, state, {
        models: state.models.concat(action.researchInterestPercentiles),
        meta: Object.assign({}, state.meta, {
          fetching: false,
          exhausted: true,
          errorFetching: false,
        }),
      });

    case TYPES.FETCH_RESEARCH_INTEREST_PERCENTILES_FAILURE:
      return Object.assign({}, state, {
        meta: Object.assign({}, state.meta, {
          fetching: false,
          errorFetching: true,
        }),
      });

    default:
      return state;
  }
};

export { reducer, reducer as default };
